import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { API_URL, REACT_APP_VERSION } from "./config";
import store from "./store";
export const endPoint =
  process.env.REACT_APP_API_URL || API_URL[process.env.NODE_ENV as any];
export const baseURL = endPoint + "/api";

const test = process.env.NODE_ENV == "test";

const attachJWT : any = (config: AxiosRequestConfig) => {
  const { url } = config;

  const oldHeaders : any = { ...config.headers };
  if (url && !url.includes("taptapassets")) {
    oldHeaders.authorization = sessionStorage.getItem("kabra:token");
  }
  return {
    ...config,
    headers: {
      ...oldHeaders,
    },
  };
};

let reloadNotified = false;
const reactVersionRegex = /^[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}$/;
const checkReactVersion = (response: AxiosResponse<any>) => {
  try {
    if (reloadNotified === false) {
      let newVersionRequired = false;
      const version = response.headers && response.headers["x-rv"];
      if (
        REACT_APP_VERSION &&
        typeof version === "string" &&
        reactVersionRegex.test(version) &&
        reactVersionRegex.test(REACT_APP_VERSION)
      ) {
        const reactVArray = REACT_APP_VERSION.split(".");
        const requiredVArray = version.split(".");
        for (let i = 0; i < 3; i++) {
          if (Number(reactVArray[i]) < Number(requiredVArray[i])) {
            newVersionRequired = true;
          } else if (Number(reactVArray[i]) > Number(requiredVArray[i])) {
            break;
          }
        }
      }
      if (newVersionRequired) {
        reloadNotified = true;
        store.dispatch({
          type: "SET_RELOAD_APP_DIALOG",
          payload: true,
        });
      }
    }
  } catch (e) {}
  return response;
};

const API = axios.create({
  baseURL: baseURL + "/",
  headers: {
    authorization: sessionStorage.getItem("kabra:token"),
  },
});
// API.defaults.withCredentials = true;

if (!test) {
  API.interceptors.request.use(attachJWT);
  axios.interceptors.request.use(attachJWT);
  API.interceptors.response.use(checkReactVersion);
  axios.interceptors.response.use(checkReactVersion);
}

export default API;
